import { Component, OnInit, OnDestroy} from '@angular/core';
import { AAGoogleMapEvents, AARoutePlannerEvents} from 'src/app/core/events/events';
import { EventsService } from 'src/app/core/services/events.service';
import { RoutePlannerDataModel, AALocationModel } from 'src/app/modules/route-planner/models/route-model';
import { ILatLng, IGoogleMap } from 'src/app/core/models/google-map-models';
import { Enums } from 'src/app/modules/route-planner/enums/route.enum';
import { GoogleMapStoreService } from '../../services/google-map-store/google-map-store.service';
import { GoogleMapEventHandlerService } from '../../services/google-map-event-handler.service';
import { GoogleMapMarkerData } from '../../models/google-map-model';
import { GoogleMapType } from '../../enums/google-map-enum';
import { RoutePlannerViaService } from 'src/app/modules/route-planner/services/route-via/route-via.service';

@Component({
    selector: 'aa-google-context-menu',
    templateUrl: './aa-google-context-menu.component.html',
    styleUrls: ['./aa-google-context-menu.component.scss'],
    standalone: false
})
export class AAGoogleContextMenuComponent implements OnInit, OnDestroy {

    constructor(private eventServices: EventsService,
        private viaService: RoutePlannerViaService,
        private googleMapEventHandler: GoogleMapEventHandlerService,
        private googleMapStore: GoogleMapStoreService) {}

    public routeDataModel: RoutePlannerDataModel;
    public fromLocationModel: AALocationModel;
    public toLocationModel: AALocationModel;
    private mapLatLng: ILatLng;

    ngOnInit() {
        this.eventServices.on(AAGoogleMapEvents.MOUSE_CLICKED, this.mapClickedHandler);
    }

    ngOnDestroy() {
        this.eventServices.remove(AAGoogleMapEvents.MOUSE_CLICKED, this.mapClickedHandler);
    }

    get googleMap(): IGoogleMap {
        return this.googleMapStore.getGoogleMap(GoogleMapType.ROUTE_PLANNER);
    }

    private mapClickedHandler = (latLng: ILatLng) => {
        this.mapLatLng = latLng;
    }

    directionsCenterHere(event: any) {
        const googleMapModel = this.googleMapStore.getGoogleMapModel(GoogleMapType.ROUTE_PLANNER);
        googleMapModel.mapInstance.setMapToCenter(this.googleMap, this.mapLatLng);
        this.mapLatLng = null;
    }

    directionsFromHere(event: any) {
        this.requestToAddNewLocation(Enums.RouteType.FromDestination);
    }

    directionsToHere(event: any) {
        this.requestToAddNewLocation(Enums.RouteType.ToDestination);
    }

    directionsViaHere($event) {
        if (this.viaService.viaRouteList.length < this.viaService.getMaxRoute) {
            this.requestToAddNewLocation(Enums.RouteType.ViaDestination);
        } else {
            this.eventServices.dispatch(AARoutePlannerEvents.ADD_VIA_ROUTE);
        }
    }

    private requestToAddNewLocation(routeType: Enums.RouteType): void {
        const markerData: GoogleMapMarkerData = new GoogleMapMarkerData();
        markerData.draggedLatLng = this.mapLatLng;

        this.googleMapEventHandler.requestToAddNewLocation(routeType, markerData);
        this.mapLatLng = null;
    }

}
